import { Fragment } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { baseUrl } from "../../utils/APi";
import { useTranslation } from "react-i18next";
import img1 from "../../assets/cat1.jpg";
import img2 from "../../assets/cat2.jpg";
import img3 from "../../assets/cat3.jpg";
import img4 from "../../assets/cat4.jpg";
const BannerBottom = () => {
  const { category } = useSelector((state) => state.Productslice);
  const { t } = useTranslation();
  return (
  <section className="container mt-60">
        <div className="row">
<div className="col-md-3 col-sm-6 mb-50">
  <div className="service-item-box">
    <div className="icon-holder">
      <i className="fa fa-usd"></i>
    </div>
    <div className="service-text">
      <h3>money back</h3>
      <p>60 Days Money Back</p>
    </div>
  </div>            
</div> 

<div className="col-md-3 col-sm-6 mb-50">
  <div className="service-item-box">
    <div className="icon-holder">
      <i className="fa fa-envelope-o"></i>
    </div>
    <div className="service-text">
      <h3>fast delivery</h3>
      <p>Less than 5 days</p>
    </div> 
  </div>            
</div>

<div className="col-md-3 col-sm-6">
  <div className="service-item-box">
    <div className="icon-holder">
      <i className="fa fa-life-ring"></i>
    </div>
    <div className="service-text">
      <h3>customers support</h3>
      <p>24/7 Online Consultation</p>
    </div>
  </div>            
</div> 

<div className="col-md-3 col-sm-6">
  <div className="service-item-box">
    <div className="icon-holder">
      <i className="fa fa-globe"></i>
    </div>
    <div className="service-text">
      <h3>free shipping</h3>
      <p>Free Shipping Above $100</p>
    </div>  
  </div>            
</div> 

</div>
  </section>
  );
};

export default BannerBottom;
